import React from 'react'
const PopupMessage = (props) => {
  const { btn } = props
  return (
    <>
      <div className="popup-overlay ">
        <div className="popup-warp">
          <div className="popup-inner">
            <div className="icon-popup"></div>
            <h3 className="name-popup">Thông báo</h3>
            <div className="content-popup" dangerouslySetInnerHTML={{ __html: props.content }}></div>
            {btn.nameBtn2 && btn.nameBtn1 && !props.groupBtnBlock && (
              <div className="group-btn-inline">
                <button
                  type="button"
                  className="btn btn-primary btn-border btn-block"
                  onClick={props.clickAction1}
                  dangerouslySetInnerHTML={{ __html: btn.nameBtn1 }}
                ></button>
                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  onClick={props.clickAction2}
                  dangerouslySetInnerHTML={{ __html: btn.nameBtn2 }}
                ></button>
              </div>
            )}
            {btn.nameBtn2 && btn.nameBtn1 && props.groupBtnBlock && (
              <div className="btn-wrapper">
                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  onClick={props.clickAction1}
                  dangerouslySetInnerHTML={{ __html: btn.nameBtn1 }}
                ></button>
                <button
                  type="button"
                  className="btn btn-primary btn-block  btn-border"
                  onClick={props.clickAction2}
                  dangerouslySetInnerHTML={{ __html: btn.nameBtn2 }}
                ></button>
              </div>
            )}
            {btn.nameBtn && (
              <button
                type="button"
                className="btn btn-primary btn-block"
                style={{ maxWidth: '100%' }}
                onClick={props.clickAction}
                dangerouslySetInnerHTML={{ __html: btn.nameBtn }}
              ></button>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
export default PopupMessage
